import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from "reactstrap";

import { connect } from "react-redux";
import { setSchemasTemplates, saveName } from "../../../store/actions";
import ReactMultiSelect from "./MultiSelect";
import ReactSelect from "./Select";

class AddModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      errors:{},
      name: "",
      epc_id: "",
      asset_id: "",
      contract_id: ""
    };
  }
  handleSelect = (value, mode) => {
    console.log(value)
    let mykey = value.key;
    let myvalue = value.id;

    let multivalue = [];
    let multikey = "";
    if (mode === "multi") {

      if(value.length !== 0){
        value.map(data => {
          multikey = data.key;
          multivalue.push(data.id);
          return data;
        });
        this.setState({ [multikey]: multivalue });
      } else {
        this.setState({ contract_id: '' });
      }
    } else {
      this.setState({ [mykey]: myvalue });
    }
  };
  handleChange = event => {
    this.setState({ name: event.target.value });
  };
  handleClick = () => {
    const {name,contract_id,epc_id,asset_id} = this.state;
    console.log(name)
    if(name && !contract_id){
      this.setState({errors:{contract_id:true}});
    }else if(contract_id && !name){
      this.setState({errors:{name:true}});
    }else if(!contract_id && !name){
      this.setState({errors:{contract_id:true,name:true}});
    }else {
      this.setState({errors:{contract_id:true,name:true}});
      const data = {epc_id, asset_id, contract_id};

      this.props.setSchemasTemplates(data);
      this.props.saveName(name);
      this.props.history.push("/asset-schemas/add-schema");
    }
  };

  render() {
    const {errors} = this.state;
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>Add new asset scheme</ModalHeader>
          <ModalBody>
            <CardBody>
              <Row>
                <Col xs="8">
                  <FormGroup onSubmit={() => {}}>
                    <Label htmlFor="name">Set a name</Label>
                    <Input
                      type="text"
                      id="name"
                      value={this.state.name}
                      placeholder="Enter your name"
                      onChange={this.handleChange}
                      required
                    />
                    {errors.name && <p style={{color:'red'}}>Name is Required</p>}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="8">
                  <FormGroup>
                    <Label htmlFor="name">Select asset type</Label>{" "}
                    <ReactSelect
                      allSchemas={this.props.allSchemas.schemas.asset_schemas}
                      handleSelect={this.handleSelect}
                      state_key={"asset_id"}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="8">
                  <FormGroup>
                    <Label htmlFor="name">Select contract</Label>{" "}
                    <ReactMultiSelect
                      allSchemas={
                        this.props.allSchemas.schemas.contract_schemas
                      }
                      handleSelect={this.handleSelect}
                      state_key={"contract_id"}
                    />
                    {errors.contract_id && <p style={{color:'red'}}>Contract is Required</p>}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                {" "}
                <Col xs="8">
                  <FormGroup>
                    <Label htmlFor="name">Epc</Label>
                    <ReactSelect
                      allSchemas={this.props.allSchemas.schemas.epc_schemas}
                      handleSelect={this.handleSelect}
                      state_key={"epc_id"}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={this.handleClick}>
              Add
            </Button>{" "}
            <Button color="secondary" onClick={this.props.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default connect(
  null,
  { setSchemasTemplates, saveName }
)(AddModal);



// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/Modal.js